import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {Observable, of} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, map, tap, switchMap} from 'rxjs/operators';
import { EmissionCalcService } from '../../../../shared/services/emission-calc.service';

 
type OriginAddress = {value: string, label: string};
type DestinationAddress = {value: string, label: string};
type OriginPort = {value: string, label: string};
type DestinationPort = {value: string, label: string};

@Component({
    selector: 'app-emission-calculator',
    templateUrl: './emission-calculator.component.html',
    styleUrls: ['./emission-calculator.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EmissionCalculatorComponent implements OnInit {

  emissionCalForm: UntypedFormGroup;

  modeOfTransportationList:any = [
    {name:'Truck/Sea/Truck',id:1,value:'TST'},
    {name:'Sea Freight',id:2,value:'SEA'},
    {name:'Air Freight',id:3,value:'AIR'},
    {name:'Truck/Air/Truck',id:4,value:'TAT'},
    {name:'Truck',id:5,value:'TRUCK'}
  ]

  cTransportationMode:any ='TST';
  arr:any =[]
  co2Total:any = 0;
  distanceTotal:any = 0;

  originAddress:any;
  destinationAddress:any;
  originPort:any;
  destinationPort:any;
  cargoWeight:any;

  isDisabled:boolean = false;
  submitted:boolean = false;


  searching_1:boolean = false;
  searchFailed_1 = false;

  searching_2:boolean = false;
  searchFailed_2 = false;

  searching_3:boolean = false;
  searchFailed_3 = false;

  searching_4:boolean = false;
  searchFailed_4 = false;

  constructor(private _fb:UntypedFormBuilder,private emissionCalcService:EmissionCalcService) { 
    this.emissionCalForm = this._fb.group({
      cOriginAddress:new UntypedFormControl(""),
      cDestinationAddress:new UntypedFormControl(""),
      cOriginPort:new UntypedFormControl("",Validators.required),
      cDestinationPort:new UntypedFormControl("",Validators.required),
      iCargoWeight:new UntypedFormControl("",Validators.required)
    })
  }

  ngOnInit(): void {
    this.emissionCalForm.get('cOriginAddress')!.setValidators([Validators.required]);
    this.emissionCalForm.get('cDestinationAddress')!.setValidators([Validators.required]);
  }

  get f() { return this.emissionCalForm.controls; }
  onChangeTransport(){
    this.submitted = false;
    
    this.emissionCalForm.reset();
    this.arr = []

    if(this.cTransportationMode  === 'SEA' || this.cTransportationMode === 'AIR'){
      this.emissionCalForm.get('cOriginAddress')!.disable();
      this.emissionCalForm.get('cDestinationAddress')!.disable();
      this.emissionCalForm.get('cOriginAddress')!.clearValidators();
      this.emissionCalForm.get('cDestinationAddress')!.clearValidators();
      this.emissionCalForm.get('cDestinationAddress')!.reset();
      this.emissionCalForm.get('cOriginAddress')!.reset();
      this.emissionCalForm.get('cOriginPort')!.enable();
      this.emissionCalForm.get('cDestinationPort')!.enable();
    }
    else if (this.cTransportationMode  === 'TRUCK'){
      this.emissionCalForm.get('cOriginAddress')!.enable();
      this.emissionCalForm.get('cDestinationAddress')!.enable();
      this.emissionCalForm.get('cOriginPort')!.disable();
      this.emissionCalForm.get('cDestinationPort')!.disable();
      this.emissionCalForm.get('cOriginPort')!.clearAsyncValidators();
      this.emissionCalForm.get('cDestinationPort')!.clearAsyncValidators();
      this.emissionCalForm.get('cOriginPort')!.reset();
      this.emissionCalForm.get('cDestinationPort')!.reset();
    }
    else{
      this.emissionCalForm.get('cOriginAddress')!.setValidators([Validators.required]);
      this.emissionCalForm.get('cDestinationAddress')!.setValidators([Validators.required]);
      this.emissionCalForm.get('cOriginAddress')!.enable();
      this.emissionCalForm.get('cDestinationAddress')!.enable();
      this.emissionCalForm.get('cOriginPort')!.enable();
      this.emissionCalForm.get('cDestinationPort')!.enable();
    }
  }

  resultTable:any;
  isRuslatTableLoader:boolean = false;
  noData:any;
  isResulatTable:boolean = false;
  onSubmit(e:any):any{
    this.submitted = true;
    if(this.emissionCalForm.invalid){
      return false
    }
    let tempob = e.value;

    if(tempob.cOriginPort && tempob.cOriginPort.name || tempob.cOriginAddress && tempob.cDestinationAddress){
      this.isRuslatTableLoader = true;
      let reqOb = {
        cDestinationAddress:tempob.cDestinationAddress && tempob.cDestinationAddress.value?tempob.cDestinationAddress && tempob.cDestinationAddress.value:'',
        cDestinationPort:tempob.cDestinationPort && tempob.cDestinationPort.name?tempob.cDestinationPort && tempob.cDestinationPort.name:'',
        cOriginAddress:tempob.cOriginAddress && tempob.cOriginAddress.value?tempob.cOriginAddress && tempob.cOriginAddress.value:'',
        cOriginPort:tempob.cOriginPort && tempob.cOriginPort.name?tempob.cOriginPort && tempob.cOriginPort.name:"",
        iCargoWeight:tempob.iCargoWeight,
        cTransportationMode:this.cTransportationMode
      }
      this.emissionCalcService.searchAllEmissionCalculator(reqOb).subscribe((res:any)=>{
       console.log(res);
       this.noData = res;
       let parser = new DOMParser();
       let xmlDoc = parser.parseFromString(res,"text/xml");
        var i;
          // xmlDoc = res;
          var x :any= xmlDoc.getElementsByTagName("Details");
          this.arr = []
        if(x.length > 0 ){
          this.isResulatTable = true;
          this.co2Total = 0;
          this.distanceTotal= 0;
          for (i = 0; i <x.length; i++) { 
            this.arr.push({
              "From": x[i]?.getElementsByTagName("From")[0].childNodes[0].nodeValue,
              "To": x[i].getElementsByTagName("To")[0].childNodes[0].nodeValue,
              "Transport": x[i].getElementsByTagName("Transport")[0].childNodes[0].nodeValue,
              "Distance": x[i].getElementsByTagName("Distance")[0].childNodes[0].nodeValue,
              "CO2": x[i].getElementsByTagName("CO2")[0].childNodes[0].nodeValue,
            })
            this.co2Total =  this.co2Total + parseFloat(x[i].getElementsByTagName("CO2")[0].childNodes[0].nodeValue);
            this.distanceTotal = this.distanceTotal + parseFloat(x[i].getElementsByTagName("Distance")[0].childNodes[0].nodeValue);
          }
          console.log(this.arr)
        } else{
          this.isResulatTable = true;
        }
  
        
        // const parser = new xml2js.Parser({ strict: false, trim: true });
        // parser.parseString(res, (err, result) => {
        //   console.log(result);
     
        // });
        this.isRuslatTableLoader = false;
      },(error)=>{
        // console.log(error);
        this.isRuslatTableLoader = false;
      })
    }

  }


  // ORIGIN ADDRESS 
  formatterOriginAddress = (originAddress: OriginAddress) => originAddress.label;
  searchOriginAddress = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    tap(() => this.searching_1 = true),
    switchMap((term) =>  {
     if(term.length < 3 ){
      this.searching_1 = false
        return of([])
    }else{
     return this.emissionCalcService.searchOriginAddress(term).pipe(
        tap(() => this.searchFailed_1 = false),
        catchError(() => {
          this.searchFailed_1 = true;
          return of([]);
        }))
      };
    }
    ),
    tap(() => this.searching_1 = false)
  )

  // DESTINATIONS ADDRESS 
  formatterDestinationAddress = (destinationAddress: DestinationAddress) => destinationAddress.label;
  searchDestinationAddress = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    tap(() => this.searching_2 = true),
    switchMap((term) => {
        if(term.length < 3){
          this.searching_2 = false;
           return of([]);
        }else{
        return this.emissionCalcService.searchDestinationAddress(term).pipe(
            tap(() => this.searchFailed_2 = false),
            catchError(() => {
              this.searchFailed_2 = true;
              return of([]);
            }))
        }
    } 
    ),
    tap(() => this.searching_2 = false)
  )

  // DESTINATIONS PORT 
  formatterDestinationPort = (destinationPort: DestinationPort) => destinationPort.label;
  searchDestinationPort = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    tap(() => this.searching_3 = true),
    switchMap((term) => {
      if(term.length < 3){
        this.searching_3 = false
        return of([]);
      }else{
        return this.emissionCalcService.searchDestinationPort(term,this.cTransportationMode).pipe(
          tap(() => this.searchFailed_3 = false),
          catchError(() => {
            this.searchFailed_3 = true;
            return of([]);
          }))
      }
    }
    ),
    tap(() => this.searching_3 = false)
  )

  // ORIGIN PORT 
  formatterOriginPort = (originPort: OriginPort) => originPort.label;
  searchOriginPort = (text$: Observable<string>) => text$.pipe(
    debounceTime(200),
    distinctUntilChanged(),
    tap(() => this.searching_4 = true),
    switchMap((term) =>{
      if(term.length < 3){
        this.searchFailed_4 = false;
        return of([]);
      }else{
      return this.emissionCalcService.searchOriginPort(term,this.cTransportationMode).pipe(
          tap(() => this.searchFailed_4 = false),
          catchError(() => {
            this.searchFailed_4 = true;
            return of([]);
          }))
      }
    }  
    ),
    tap(() => this.searching_4 = false)
  )

  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } 
    return true;
  }
  onValuePaste(event: ClipboardEvent) {
    if(Number(event.clipboardData!.getData('text'))){
        return true
    }
    return false
    // return false;
  }

}